import 'whatwg-fetch';


export function paramsHasErrored(bool) {
    return {
        type: 'PARAMS_HAS_ERRORED',
        hasErrored: bool
    }
}

export function paramsAreLoading(bool) {
    return {
        type: 'PARAMS_ARE_LOADING',
        areLoading: bool
    }
}

export function paramsFetchDataSuccess(params) {
    return {
        type: 'PARAMS_FETCH_DATA_SUCCESS',
        params
    };
}

export function paramWsFetch(paramwid) {
    return {
        type: 'PARAM_WS_FETCH',
        paramwid
    };
}

export function paramsFetchData(url) {
    return (dispatch) => {
        dispatch(paramsAreLoading(true));
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(paramsAreLoading(false));
                return response;
            })
            .then((response) => response.json())
            .then((params) => dispatch(paramsFetchDataSuccess(params)))
            .catch(() => dispatch(paramsHasErrored(true)));
    };
}

export function paramsReceiveMesage(wsMessage) {
    return (dispatch) => {
        switch (wsMessage.type) {
            default:
                dispatch(paramWsFetch(wsMessage))
        }
    }

}


// WEBPACK FOOTER //
// ./src/lib/redux/actions/params.js